import { render, staticRenderFns } from "./payment-request.vue?vue&type=template&id=5e4d6450&scoped=true&"
import script from "./payment-request.vue?vue&type=script&lang=js&"
export * from "./payment-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d6450",
  null
  
)

export default component.exports